import { apiGet, ApiRequestError } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertEmergency } from '@/api/notification/getNotificationSos.ts'

export const apiGetAlertEmergencyDetail = async (id?: number) => {
    return await apiGet<IAlertEmergency>(`/alert/emergency/${id}`)
}

const useQueryGetAlertEmergencyDetail = (id?: number) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.getAlertEmergencyDetail(id),
        // 알림센터 목록 응답에는 처리내용(content)이 생략될 수 있으므로
        // 실시간 모드가 아니어도 상세 데이터는 반드시 한 번 조회한다.
        enabled: (id ?? -1) >= 0,
        retry: (failureCount, error) =>
            !(error instanceof ApiRequestError && error.status === 404) && failureCount < 2,
        queryFn: async () => {
            const { data } = await apiGetAlertEmergencyDetail(id)
            return data
        }
    })
}

export default useQueryGetAlertEmergencyDetail
